// extracted by mini-css-extract-plugin
export default {"Page":"maintenance_Page__0Max1","LogoImage":"maintenance_LogoImage__0WxPq","LogoMarcaDagua":"maintenance_LogoMarcaDagua__40Pgz","Title":"maintenance_Title__tASvn"};